export const getEndSpaceCounts = (text) => {
  return {
    start: text.match(/^\s*/)[0].length,
    end: text.match(/\s*$/)[0].length
  };
};


export const getElementPosition = (element) => {
  return {
    top: element.style.top || 0,
    left: element.style.left || 0,
  }
};


export const encloseAdjacentWhitespaces = (node) => {
  const prevNode = createWhitespaceNode(node.previousSibling);
  const nextNode = createWhitespaceNode(node.nextSibling);
  if (prevNode) {
    node.previousSibling.replaceWith(prevNode);
  }
  if (nextNode) {
    node.nextSibling.replaceWith(nextNode);
  }
};


export const createWhitespaceNode = (node) => {
  if (node && node.nodeType === Node.TEXT_NODE && node.nodeValue && !node.nodeValue.trim()) {
    const newNode = document.createDocumentFragment();
    newNode.appendChild(document.createElement('wbr'));
    newNode.appendChild(document.createTextNode(node.nodeValue));
    newNode.appendChild(document.createElement('wbr'));
    return newNode;
  }
  return null;
};
